import { defaultTo } from 'lodash';
import { HospitalScheduleDayModel } from './HospitalScheduleDayModel';

/**
 * This model exists to wrap a hospital schedule for a hospital id and unflatten the schedule days into a schedule array of HospitalScheduleDayModel's
 */
export class HospitalScheduleWrapperModel {
  hospitalId: number;
  schedule: HospitalScheduleDayModel[];

  constructor(init?: Partial<HospitalScheduleWrapperModel>) {
    this.hospitalId = defaultTo(init?.hospitalId, 0);
    this.schedule =
      init?.schedule?.map((s) => new HospitalScheduleDayModel(s)) ??
      ([] as HospitalScheduleDayModel[]);
  }
}
